import gql from 'graphql-tag';

export const TAGS = gql`
    query getTags {
        tags {
            _id
            name
            description
            articleCount
            version
            views
        }
    }
`;

export const TAG = gql`
    query findTagById($id: ID!) {
        document: findTagById(id: $id) {
            _id
            name
            description
            version
        }
    }
`;

export const ADD_TAG = gql`
    mutation addTag($item: TagInputAdd) {
        addTag(item: $item) {
            _id
            name
            description
            version
        }
    }
`;

export const EDIT_TAG = gql`
    mutation editTag($item: TagInputEdit) {
        editTag(item: $item) {
            _id
            name
            description
            version
        }
    }
`;

export const DELETE_TAG = gql`
    mutation deleteTag($id: ID!) {
        deleteTag(id: $id) {
            _id
        }
    }
`;
